import React, { Suspense } from 'react';
import { useSelector } from 'react-redux';

import { WidgetLoader } from './_common/WidgetLoader/WidgetLoader';
import { WidgetToggleButton } from './WidgetToggleButton/WidgetToggleButton';

const WidgetApp = React.lazy(() => import(/* webpackChunkName: "WidgetApp" */ './WidgetApp'));

export const LazyWidgetApp: React.FC = () => {
    const open = useSelector((state) => state.chat.open);
    const inited = useSelector((state) => state.history.initialised);

    if (!open && !inited) return <WidgetToggleButton showOverlap={false} />;

    return (
        <Suspense fallback={<WidgetLoader />}>
            <WidgetApp />
        </Suspense>
    );
};
